import { render } from "./IconArrowRight.vue?vue&type=template&id=45592d41&scoped=true"
const script = {}

import "./IconArrowRight.vue?vue&type=style&index=0&id=45592d41&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45592d41"]])

export default __exports__